export default function Description({ text }: any) {
  return (
    <div>
      <p className="mt-1 text-sm text-gray-500">{text}</p>
    </div>
  );
}
